
        var result = require("!!../../../node_modules/css-loader/index.js!./message.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/shared/message.component.css
// module id = 2109
// module chunks = 1